import {useMappedState} from 'redux-react-hook'

export default function useGetUserAsset () {
  const mapState = state => state?.entities?.maxWithdrawAmount || 0
  return useMappedState(mapState)
}
